import {RichText as RichTextConverter} from "@payloadcms/richtext-lexical/react";
import {SerializedEditorState} from "@payloadcms/richtext-lexical/lexical";
import {createJSXConverter} from "@/components/content/common/RichText/Converters";

type Props = {
    data: SerializedEditorState,
    theme?: "light" | "dark",
} & React.HTMLAttributes<HTMLDivElement>

export function RichText(props: Props) {
    const { className, theme, ...rest } = props;
    return (
        <RichTextConverter
            {...rest}
            className={className}
            converters={createJSXConverter(theme)}
        />
    )
}